<div class="admin-shared-files-container container">
  <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="title">لیست تخفیفات کاربر</h2>
    <div class="actions">
      <button mat-button (click)="editUserDiscount()">
        <div class="d-flex align-items-cetner">
          <jam-icon name="plus" />
          تخصیص کد تخفیف به کاربر
        </div>
      </button>
      <button
        mat-icon-button
        (click)="refreshController.next('')"
        color="primary"
      >
        <jam-icon name="refresh" />
      </button>
      <!-- <button mat-icon-button>
        <jam-icon name="more-vertical-f" />
      </button> -->
    </div>
  </div>
  <mat-divider />
  <br />

  <h1
    *ngIf="this.dataSource.data && !this.dataSource.data.length"
    style="text-align: center"
  >
    موردی پیدا نشد
  </h1>

  <div class="shared-doc-table-container mat-elevation-z2">
    <div class="example-container mat-elevation-z8">
      <div
        class="example-loading-shade"
        *ngIf="isLoadingResult || isRateLimitReached"
      >
        <mat-spinner *ngIf="isLoadingResult" />
      </div>

      <table mat-table [dataSource]="dataSource">
        <!-- Position Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>شماره</th>
          <td mat-cell *matCellDef="let element">
            {{ element.id }}
          </td>
        </ng-container>

        <ng-container matColumnDef="conditionValue">
          <th mat-header-cell *matHeaderCellDef>کف / سقف تخفیف</th>
          <td mat-cell *matCellDef="let element">
            {{ element.conditionValue || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef>کد تخفیف</th>
          <td mat-cell *matCellDef="let element">
            {{ element.code }}
          </td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>نوع تخفیف</th>
          <td mat-cell *matCellDef="let element">
            {{ element.type }}
          </td>
        </ng-container>

        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef>مقدار تخفیف</th>
          <td mat-cell *matCellDef="let element">
            {{ element.value || '-' }}
          </td>
        </ng-container>

        <!-- <ng-container matColumnDef="paid">
          <th mat-header-cell *matHeaderCellDef>امتیاز استفاده شده</th>
          <td mat-cell *matCellDef="let element">
            {{ element.paid | number: '1.' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="total">
          <th mat-header-cell *matHeaderCellDef>مجموع امتیاز</th>
          <td mat-cell *matCellDef="let element">
            {{ element.totalScores | number: '1.' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="reason">
          <th mat-header-cell *matHeaderCellDef>بابت</th>
          <td mat-cell *matCellDef="let element">
            {{ element.reason }}
          </td>
        </ng-container> -->

        <!-- Weight Column -->
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>تاریخ ثبت</th>
          <td mat-cell *matCellDef="let element">
            {{getDate(element?.createdAt) | jdate : "d mmm yyyy"}}
          </td>
        </ng-container>

        <!-- Symbol Column -->
        <!-- <ng-container matColumnDef="user">
          <th mat-header-cell *matHeaderCellDef>کاربر</th>
          <td mat-cell *matCellDef="let element">
            <button mat-flat-button>
              {{ element.user.fullName }}
            </button>
          </td>
        </ng-container> -->
        <!-- <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>عملیات</th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button color="primary">
              <jam-icon name="eye-f" />
            </button>
          </td>
        </ng-container> -->

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <mat-paginator
        [pageSizeOptions]="[5, 10, resultsLength]"
        [length]="resultsLength"
        class="paginator"
        showFirstLastButtons
        aria-label="Select page of periodic elements"
      />
    </div>
  </div>
</div>
